<template>
  <div class="community-page-header">
    <div class="container text-center py-5">
      <h1 class="mb-4">BEM-VINDO À COMUNIDADE</h1>
      <div class="mb-5">
        Um espaço para compartilhar conhecimento, tirar dúvidas e conhecer
        outros alunos.
      </div>
      <button
        class="btn btn-light text-primary btn-strong text-uppercase rounded-pill"
        @click="dialog = true"
      >
        Regras da comunidade
      </button>
    </div>

    <b-modal
      v-model="dialog"
      hide-header
      hide-footer
      centered
      :no-close-on-backdrop="!$user.user.accepted_term_community"
      size="lg"
    >
      <div class="text-center mb-4">
        <h1>BEM-VINDO À COMUNIDADE</h1>
        Um espaço para compartilhar conhecimento, tirar dúvidas e conhecer
        outros alunos.
      </div>
      <p>
        Aproveite este espaço para se apresentar e conhecer os demais
        participantes do Guerrilha Way, e utilize-o para interação e discussão
        dos conteúdos das disciplinas da formação. Esta é uma grande
        oportunidade para que você construa seu networking, amplie seus
        conhecimentos teóricos e compartilhe suas experiências pessoais e
        profissionais.
      </p>
      <p>
        Abaixo, citamos as regras a serem seguidas durante sua participação
        nessa comunidade:
      </p>
      <ol>
        <li>
          É proibido qualquer ato de desrespeito à Equipe de Suporte, à Equipe
          Pedagógica, aos docentes e aos demais alunos da formação;
        </li>
        <li>
          É proibido o compartilhamento de links de conteúdo não relacionado às
          disciplinas do curso, bem como de imagens, “memes”, figurinhas e
          similares.
        </li>
        <li>
          É proibido criar grupos de WhatsApp e outras redes sociais dentro da
          comunidade.
        </li>
        <li>
          É proibido discutir temas não relacionados às disciplinas do curso (a
          exemplo: política, religião, futebol etc.).
        </li>
        <li>
          Não recomendamos a exposição e/ou o compartilhamento de seus dados e
          informações pessoais, pois o Guerrilha Way NÃO se responsabilizará por
          danos morais, materiais ou de qualquer outra natureza que venham a ser
          padecidos em razão do uso indevido de seus dados por terceiros.
        </li>
        <li>
          É dever inegociável de todos os alunos da Comunidade o respeito ao
          sigilo profissional, a fim proteger os pacientes dos alunos e
          resguardar a confidencialidade prevista nos Códigos de Ética
          profissionais.
        </li>
        <li>
          Os que não seguirem as regras acima estarão sujeitos às punições
          dentro da área Comunidade, a saber: advertência, suspensão, expulsão.
        </li>
        <li>
          Essa comunidade é uma ferramenta viva e em constante transformação,
          por isso reservamos o direito de alterar as regras dessa área sem
          qualquer consulta ou aviso prévio. Por isso, crie o hábito de
          verificar as regras de tempos em tempos.
        </li>
      </ol>

      <div
        v-if="!$user.user.accepted_term_community"
        class="d-lg-flex justify-content-between align-items-center"
      >
        <b-form-checkbox v-model="terms">
          Eu li e estou de acordo com as Regras da Comunidade
        </b-form-checkbox>
        <button
          :disabled="!terms || loading"
          class="btn btn-strong text-uppercase rounded-pill"
          :class="{ 'btn-light text-primary': terms, 'btn-secondary': !terms }"
          @click="accept"
        >
          <loading :show="loading">
            Participar da Comunidade
          </loading>
        </button>
      </div>

      <div v-else class="d-flex justify-content-center">
        <button
          class="btn btn-strong text-uppercase rounded-pill btn-light text-primary"
          @click="dialog = false"
        >
          Participar da Comunidade
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {
      dialog: !this.$user.user.accepted_term_community,
      terms: false,
      loading: false
    };
  },
  methods: {
    accept() {
      if (!this.terms || this.loading) return;
      this.loading = true;
      this.$store
        .dispatch("user/acceptedTermCommunity")
        .then(() => {
          this.dialog = false;
        })
        .catch(() => {
          this.$message.error("Erro");
        })
        .finally(() => {
          this.loading = false;
        });
    }
  }
};
</script>

<style lang="scss" scoped>
.community-page-header {
  background-image: linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)),
    url("../../assets/images/community.jpeg");
  background-size: cover;
  background-position-x: center;
  background-position-y: center;
  color: white;

  h1 {
    letter-spacing: 0.115em;
    text-transform: uppercase;
    font-size: 40px;
  }
}
</style>
